import React, {useEffect, useState} from "react";
import "./style.scss";
import {passwordPolicyRegex} from "../../helpers/auth";

interface Props {
    password: string;
}

export const PasswordStrength: React.FC<Props> = ({password}) => {
    const [color, setColor] = useState("#F51010");
    const [percentage, setPercentage] = useState(0);

    useEffect(() => {
        if (!password) {
            setColor("#F51010");
            setPercentage(0);
            return;
        }

        const regexLevel2 = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/);
        const regexLevel3 = new RegExp(passwordPolicyRegex());
        if (regexLevel3.test(password)) {
            // green case
            setColor("#01CC15");
            setPercentage(100);
        } else if (regexLevel2.test(password)) {
            // yellow case
            setColor("#FDCA17");
            setPercentage(66);
        } else {
            // red case
            setColor("#F51010");
            setPercentage(33);
        }
    }, [password]);

    return (
        <div className="passwordStrength">
            <div className="passwordStrength__barWrapper">
                <div
                    className="passwordStrength__bar"
                    style={{
                        backgroundColor: color,
                        width: `${percentage}%`,
                    }}
                ></div>
            </div>
        </div>
    );
};
